import {useEffect, useRef} from "react";
import lscache from "lscache";

import {useAppDispatch} from "../../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../../store/hooks/use_app_selector";
import {PHONE_VERIFICATION_MODAL_DISMISSED} from "../../../km_app/constants/storage_keys";
import {IUserProfile} from "../../interfaces/IUserProfile";
import {
    handleCloseUpdatePhoneNumberModal,
    handleOpenUpdatePhoneNumberModal,
    phoneVerificationSucceeded,
    reopenPhoneVerificationModal,
    requestPhoneVerification
} from "../../state/user_phone_verification_slice";
import {PHONE_VERIFICATION_PENDING_ACTION_NONE} from "../types/phone_verification_types";
import {getLeadPayloadPhone, isLeadSendPendingAction, isPendingActionSuppressingPassivePrompt} from "../utils/phone_verification_pending_action";

interface IUsePhoneVerificationModalOrchestrationOptions {
    userProfile: IUserProfile | undefined;
    refetchUserProfile: () => void;
}

export const usePhoneVerificationModalOrchestration = ({userProfile, refetchUserProfile}: IUsePhoneVerificationModalOrchestrationOptions) => {
    const dispatch = useAppDispatch();
    const {isPhoneVerificationModalSuppressed, openPhoneVerificationModal, openUpdatePhoneNumberModal, pendingAction} = useAppSelector(
        (state) => state.userPhoneVerification
    );
    const skipUpdatePhonePromptRef = useRef(false);
    const wasPhoneVerificationSuppressedRef = useRef(false);

    const isLeadSendPending = isLeadSendPendingAction(pendingAction);
    const skipPassivePhonePrompt = isPendingActionSuppressingPassivePrompt(pendingAction);
    const phoneNumber = userProfile?.phone || getLeadPayloadPhone(pendingAction);
    const hasPhone = Boolean(phoneNumber);

    useEffect(() => {
        if (hasPhone) skipUpdatePhonePromptRef.current = false;
    }, [hasPhone]);

    useEffect(() => {
        const isDismissed = lscache.get(PHONE_VERIFICATION_MODAL_DISMISSED);

        if (isPhoneVerificationModalSuppressed) {
            wasPhoneVerificationSuppressedRef.current = true;
            return;
        }

        if (wasPhoneVerificationSuppressedRef.current) {
            wasPhoneVerificationSuppressedRef.current = false;
            return;
        }

        if (skipPassivePhonePrompt || openUpdatePhoneNumberModal) return;

        if (userProfile && userProfile.phone && !userProfile.phone_verified && !openPhoneVerificationModal && !isDismissed) {
            dispatch(requestPhoneVerification({pendingAction: PHONE_VERIFICATION_PENDING_ACTION_NONE}));
        } else if (userProfile?.phone_verified && openPhoneVerificationModal) {
            dispatch(phoneVerificationSucceeded());
        }
    }, [dispatch, isPhoneVerificationModalSuppressed, skipPassivePhonePrompt, openPhoneVerificationModal, openUpdatePhoneNumberModal, userProfile]);

    useEffect(() => {
        if (!isLeadSendPending || !openUpdatePhoneNumberModal) return;

        // Lead form already collected the number - do not stack the phone number modal over SMS.
        dispatch(handleCloseUpdatePhoneNumberModal());
        dispatch(reopenPhoneVerificationModal());
    }, [dispatch, isLeadSendPending, openUpdatePhoneNumberModal]);

    useEffect(() => {
        if (!openPhoneVerificationModal || openUpdatePhoneNumberModal) return;
        if (hasPhone) return;

        // Wait for profile/cache after lead save or update-phone success instead of reopening confirm modal.
        if (isLeadSendPending || skipUpdatePhonePromptRef.current) {
            void refetchUserProfile();
            return;
        }

        if (!userProfile) return;

        dispatch(handleOpenUpdatePhoneNumberModal());
    }, [dispatch, hasPhone, isLeadSendPending, openPhoneVerificationModal, openUpdatePhoneNumberModal, refetchUserProfile, userProfile]);

    return {
        phoneNumber,
        hasPhone,
        isLeadSendPending,
        openPhoneVerificationModal,
        openUpdatePhoneNumberModal,
        beginSkipUpdatePhonePrompt: () => {
            skipUpdatePhonePromptRef.current = true;
        },
        endSkipUpdatePhonePrompt: () => {
            skipUpdatePhonePromptRef.current = false;
        }
    };
};
import {useEffect, useRef} from "react";
import lscache from "lscache";

import {useAppDispatch} from "../../../../store/hooks/use_app_dispatch";
import {useAppSelector} from "../../../../store/hooks/use_app_selector";
import {PHONE_VERIFICATION_MODAL_DISMISSED} from "../../../km_app/constants/storage_keys";
import {IUserProfile} from "../../interfaces/IUserProfile";
import {
    handleCloseUpdatePhoneNumberModal,
    handleOpenUpdatePhoneNumberModal,
    phoneVerificationSucceeded,
    reopenPhoneVerificationModal,
    requestPhoneVerification
} from "../../state/user_phone_verification_slice";
import {PHONE_VERIFICATION_PENDING_ACTION_NONE} from "../types/phone_verification_types";
import {getLeadPayloadPhone, isLeadSendPendingAction, isPendingActionSuppressingPassivePrompt} from "../utils/phone_verification_pending_action";

interface IUsePhoneVerificationModalOrchestrationOptions {
    userProfile: IUserProfile | undefined;
    refetchUserProfile: () => void;
}

export const usePhoneVerificationModalOrchestration = ({userProfile, refetchUserProfile}: IUsePhoneVerificationModalOrchestrationOptions) => {
    const dispatch = useAppDispatch();
    const {isPhoneVerificationModalSuppressed, openPhoneVerificationModal, openUpdatePhoneNumberModal, pendingAction} = useAppSelector(
        (state) => state.userPhoneVerification
    );
    const skipUpdatePhonePromptRef = useRef(false);
    const wasPhoneVerificationSuppressedRef = useRef(false);

    const isLeadSendPending = isLeadSendPendingAction(pendingAction);
    const skipPassivePhonePrompt = isPendingActionSuppressingPassivePrompt(pendingAction);
    const phoneNumber = userProfile?.phone || getLeadPayloadPhone(pendingAction);
    const hasPhone = Boolean(phoneNumber);

    useEffect(() => {
        if (hasPhone) skipUpdatePhonePromptRef.current = false;
    }, [hasPhone]);

    useEffect(() => {
        const isDismissed = lscache.get(PHONE_VERIFICATION_MODAL_DISMISSED);

        if (isPhoneVerificationModalSuppressed) {
            wasPhoneVerificationSuppressedRef.current = true;
            return;
        }

        if (wasPhoneVerificationSuppressedRef.current) {
            wasPhoneVerificationSuppressedRef.current = false;
            return;
        }

        if (skipPassivePhonePrompt || openUpdatePhoneNumberModal) return;

        if (userProfile && userProfile.phone && !userProfile.phone_verified && !openPhoneVerificationModal && !isDismissed) {
            dispatch(requestPhoneVerification({pendingAction: PHONE_VERIFICATION_PENDING_ACTION_NONE}));
        } else if (userProfile?.phone_verified && openPhoneVerificationModal) {
            dispatch(phoneVerificationSucceeded());
        }
    }, [dispatch, isPhoneVerificationModalSuppressed, skipPassivePhonePrompt, openPhoneVerificationModal, openUpdatePhoneNumberModal, userProfile]);

    useEffect(() => {
        if (!isLeadSendPending || !openUpdatePhoneNumberModal) return;

        // Lead form already collected the number - do not stack the phone number modal over SMS.
        dispatch(handleCloseUpdatePhoneNumberModal());
        dispatch(reopenPhoneVerificationModal());
    }, [dispatch, isLeadSendPending, openUpdatePhoneNumberModal]);

    useEffect(() => {
        if (!openPhoneVerificationModal || openUpdatePhoneNumberModal) return;
        if (hasPhone) return;

        // Wait for profile/cache after lead save or update-phone success instead of reopening confirm modal.
        if (isLeadSendPending || skipUpdatePhonePromptRef.current) {
            void refetchUserProfile();
            return;
        }

        if (!userProfile) return;

        dispatch(handleOpenUpdatePhoneNumberModal());
    }, [dispatch, hasPhone, isLeadSendPending, openPhoneVerificationModal, openUpdatePhoneNumberModal, refetchUserProfile, userProfile]);

    return {
        phoneNumber,
        hasPhone,
        isLeadSendPending,
        openPhoneVerificationModal,
        openUpdatePhoneNumberModal,
        beginSkipUpdatePhonePrompt: () => {
            skipUpdatePhonePromptRef.current = true;
        },
        endSkipUpdatePhonePrompt: () => {
            skipUpdatePhonePromptRef.current = false;
        }
    };
};
